import { ApiState } from "infrastructure/api";
import { resourceSliceFactory } from "infrastructure/store/state";
import type { SeenFilterValues, TransactionsState } from "./types";

export const emptySeenFilterValues: SeenFilterValues = {
    currency: [],
    status: [],
    methodId: [],
    via: [],
    MOR: [],
    merchantId: [],
    PSP: []
};

const state: TransactionsState = resourceSliceFactory({
    transactionDetailsLoadingState: ApiState.Idle,
    seenFilterValues: emptySeenFilterValues,
    seenFilterValuesCriteriaKey: ''
});

export const sliceToken = 'transactions';

export default state;
